import { API_BASE_URL } from "./config";
import { CATEGORY_API_PATHS } from "../constants/agencyCategories";

export const ENDPOINTS = {
  auth: {
    login: "/api/v1/auth/login",
  },
  users: "/api/v1/users",
  orders: "/api/v1/orders/",
};

/** Relative API path for use with apiClient */
export const getCategoryPath = (category, id = null) => {
  const path = CATEGORY_API_PATHS[category];
  if (!path) return null;
  return id ? `${path}/${id}` : path;
};

/** Full URL for fetch or external use */
export const getCategoryEndpoint = (category, id = null) => {
  const relative = getCategoryPath(category, id);
  return relative ? `${API_BASE_URL}${relative}` : null;
};

export const getAllCategoryPaths = () => Object.values(CATEGORY_API_PATHS);
